<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item v-if="isLeader" url="/dashboard" :class="getRoute() === 'dashboard' ? 'active' : ''" :navText="'Dashboard'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
        <sidenav-item url="/data-jemaat" :class="getRoute() === 'data-jemaat' ? 'active' : ''" :navText="'Data Jemaat'">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
        <sidenav-item url="/data-keluarga" :class="getRoute() === 'dashboard-keluarga' ? 'active' : ''"
          :navText="'Data Keluarga'">
          <template v-slot:icon>
            <i class="ni ni-folder-17 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
        <sidenav-item v-if="isAdmin" url="/easy-find" :class="getRoute() === 'easy-find' ? 'active' : ''" :navText="'Easy Find (NEW)'">
          <template v-slot:icon>
            <i class="ni ni-air-baloon text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
        <sidenav-item url="/ubah-password" :class="getRoute() === 'ubah-password' ? 'active' : ''" :navText="'Ubah Password'">
          <template v-slot:icon>
            <i class="ni ni-lock-circle-open text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
        <sidenav-item url="/logout" :class="getRoute() === 'logout' ? 'active' : ''" :navText="'Logout'">
          <template v-slot:icon>
            <i class="ni ni-key-25 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isLeader() {
      return this.$store.getters.isAdmin || this.$store.getters.isKetuaWilayah || this.$store.getters.isKetuaSektor;
    }
  },
  components: {
    SidenavItem
  },
  mounted(){
    // Only check user if sidenav is visible
    if (this.$store.state.showSidenav) {
      this.checkUser()
    }
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    checkUser() {
      const token = localStorage.getItem("token")
      if (!token) {
        // If no token, redirect to signin
        this.$router.push('/signin')
        return
      }

      this.axios.get(process.env.VUE_APP_API_URL + "user", {
        headers: {
          "Authorization": "Bearer " + token
        }
      }).then((resp) => {
        this.$store.commit('setUser', resp.data.user)
      }).catch(() => {
        this.$router.push('/signin')
      })
    }
  }
};
</script>
